app.directive('logoTitle', function () {
    return {
        templateUrl:'templates/directives/logo-title.html'
    }
});